import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Assessment as AssessmentIcon } from '@mui/icons-material';

const WorkOrderReportHeader: React.FC = () => {
  return (
    <Box
      sx={{
        p: 3,
        borderBottom: '2px solid #3b82f6',
        backgroundColor: '#ffffff',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <AssessmentIcon sx={{ fontSize: '2rem', color: '#3b82f6' }} />
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#1e293b' }}>
            Work Order Reports
          </Typography>
          <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
            Facility maintenance ticket analytics and insights
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default WorkOrderReportHeader;
